// extracted by mini-css-extract-plugin
export default {"wrapper":"AuthTemplate_wrapper__k0NmK","box":"AuthTemplate_box__NJIe8"};